import { type AppState } from '../../common/types';

export const getLastPostSlug = (state: AppState) => state.lastPostSlug;
